// @ts-nocheck
/** 外部拷贝过来的 JS，当前文件暂不进行 TS 检测 */
import { reactive, readonly } from "vue";
import { loginGoogle } from '@/api/models/system'
import { sensorsTrack, getSensorsInstance, sensorsLogin,  SENSORS_EVENT, registerSuccessTrack } from './sensors.client'
import { customEventFn, eventName } from '@/plugins/bi-sa.client'

let Vue3GoogleOauth
Vue3GoogleOauth = reactive({
  isInit: false,
  isAuthorized: false,
})
const googleAuth = (function () {

  function installClient() {
    const apiUrl = 'https://apis.google.com/js/api.js';
    return new Promise((resolve) => {
      let script = document.createElement('script');
      script.src = apiUrl;
      script.onreadystatechange = script.onload = function () {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          setTimeout(function () {
            resolve({})
          }, 500)
        }
      }
      document.getElementsByTagName('head')[0].appendChild(script);
    })
  }

  function initClient(config: any) {
    return new Promise((resolve, reject) => {
      window.gapi.load('auth2', () => {
        window.gapi.auth2.init(config)
          .then(() => {
            resolve(window.gapi);
          }).catch((error: any) => {
            reject(error);
          })
      })
    })

  }

  function Auth() {
    if (!(this instanceof Auth))
      return new Auth();
    this.instance = null; /* window.gapi.auth2.getAuthInstance() */
    this.load = (config) => {
      installClient()
        .then(() => {
          return initClient(config)
        })
        .then((gapi) => {
          this.instance = gapi.auth2.getAuthInstance();

          this.prompt = config.prompt;
          Vue3GoogleOauth.instance = gapi.auth2.getAuthInstance();
          Vue3GoogleOauth.isInit = true;
          Vue3GoogleOauth.isAuthorized = this.instance.isSignedIn.get();
        }).catch((error) => {
          console.error(error);
        })
    };

    this.signIn = () => {
      return new Promise((resolve, reject) => {
        if (!this.instance) {
          reject(false)
          return
        }
        this.instance.signIn()
          .then(googleUser => {
            Vue3GoogleOauth.isAuthorized = this.instance.isSignedIn.get();
            resolve(googleUser);
          })
          .catch(error => {
            reject(error);
          })
      })
    };

    this.getAuthCode = () => {
      return new Promise((resolve, reject) => {
        if (!this.instance) {
          reject(false)
          return
        }
        this.instance.grantOfflineAccess({ prompt: this.prompt })
          .then(function (resp) {
            resolve(resp.code)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    };

    this.signOut = () => {
      return new Promise((resolve, reject) => {
        if (!this.instance) {
          reject(false)
          return
        }
        this.instance.signOut()
          .then(() => {
            Vue3GoogleOauth.isAuthorized = false;
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    };
  }

  return new Auth()
})();

const GAuth = {
  install: (app, options) => {
    /* eslint-disable */
    //set config
    let config = null
    let defaultConfig = { scope: 'profile email', prompt: 'select_account' };
    if (typeof options === 'object') {
      config = Object.assign(defaultConfig, options);
      if (!options.clientId) {
        throw new Error('clientId is required');
      }
    } else {
      throw new TypeError('invalid option type. Object type accepted only');
    }

    //Install Vue plugin
    googleAuth.load(config);
    app.config.globalProperties.$gAuth = googleAuth;
    app.provide('Vue3GoogleOauth', readonly(Vue3GoogleOauth));
  },
  $gAuth: googleAuth
}


/**
 * Google auto2.0
 */
const googleLogin = async (id_token: string) => {
  try {
    const userInfo = await loginGoogle(id_token)
    sensorsTrack(getSensorsInstance())(SENSORS_EVENT.LoginSuccess, { LoginMethod: 'google' })
    if(!userInfo.isExistAccount || userInfo.isRegister) {
      registerSuccessTrack('google')
      customEventFn(eventName.registerSuccess,  { register_method: 'google',  register_source: 'normal'})
    }
    const { $setUserInfo } = useNuxtApp()
    // 写入登录状态
    await $setUserInfo(userInfo, '', true)
  } catch(e: any) {
    console.error(e)
    showToast(e.msg || e.message)
  }
}

export default defineNuxtPlugin((NuxtApp) => {
  // 特殊非用户侧页面无需加载
  if(useRoute().name === 'pvHome') return

  const runtimeConfig = useRuntimeConfig()
  const { googleClientId: GOOGLE_CLIENT_ID } = runtimeConfig.public

  const gAuthOptions = { clientId: GOOGLE_CLIENT_ID, scope: 'email', prompt: 'consent', fetch_basic_profile: false }

  NuxtApp.vueApp.use(GAuth, gAuthOptions)

  return { provide: { GAuth } }
})

// 谷歌一键登录
const _window: any = window
_window.googleLoginCallback =  (response: any) => {
  let jwt_str = response.credential
  if(!jwt_str) return null;
  googleLogin(jwt_str)
}
var oHead = document.getElementsByTagName('head').item(0)
var oScript= document.createElement("script")
oScript.type = "text/javascript"
oScript.async = true
oScript.src = 'https://accounts.google.com/gsi/client'
oHead.appendChild(oScript)